module.exports = __webpack_public_path__ + "img/citi.878452da.svg";